import React from 'react';
import styled from 'styled-components';

import Spacer from 'components/ui/Spacer';
import InputFile from 'components/landlord_app/maintenance/tickets/InputFile';

import { getTranslatedString } from 'helpers/i18n';
import { maintenanceTicketAcceptedFileTypes } from 'helpers/FileHelper';

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;
const StyledP = styled.p`
  color: #6f6f6f;
`;

const AttachPhotos = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  imageMaxSize,
  readOnly,
}) => {
  return (
    <StyledSectionContainer>
      <Spacer mb={0.3}>
        <FormTitle>
          {getTranslatedString('landlordPortal.maintenance.tickets.attachPhotos')}
        </FormTitle>
      </Spacer>
      <InputFile
        newFiles={values.file}
        oldFiles={values.photos}
        name="file"
        onChange={(newValues, uploadedValues) => {
          setFieldValue('files', newValues);
        }}
        onDropVerbiage={getTranslatedString('landlordPortal.maintenance.tickets.dropFileHere')}
        dropFileVerbiage={getTranslatedString('landlordPortal.maintenance.tickets.dragAndDrop')}
        browseVerbiage={getTranslatedString('landlordPortal.maintenance.tickets.orBrowse')}
        rejectFileError={getTranslatedString('landlordPortal.maintenance.tickets.cannotAcceptFile')}
        acceptedFiles={maintenanceTicketAcceptedFileTypes}
        readOnly={readOnly}
      />
      <StyledP>
        {getTranslatedString('landlordPortal.maintenance.tickets.noPersonalMaxSize', {
          imageMaxSize: imageMaxSize,
        })}
      </StyledP>
    </StyledSectionContainer>
  );
};

export default AttachPhotos;
